<template>
  <div class="user box-shadow">
    <div class="user__body padding10">
      <div class="fs20 fWB borderBottom paddingBottom10">修改密码</div>
      <div class="margin10 bcGrey marginTop20 padding10 box-shadow flexGrow1 flex directionColumn">
        <div class="flex">
          <div class="wFP padding10">
            <div class="fs15 marginBottom10">基本信息</div>
            <el-form ref="form" label-position="right" :model="form" label-width="100px" :rules="rules">
              <el-form-item label="账号">
                <el-input v-model="form.phonenumber" disabled />
              </el-form-item>
              <el-form-item label="密码" prop="password">
                <el-input
                  v-model="form.password"
                  type="password"
                  auto-complete="off"
                  placeholder="密码"
                  @keyup.enter.native="onSubmit"
                >
                  <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
                </el-input>
              </el-form-item>
              <el-form-item label="确认密码" prop="confirmPassword">
                <el-input
                  v-model="form.confirmPassword"
                  type="password"
                  auto-complete="off"
                  placeholder="确认密码"
                  @keyup.enter.native="onSubmit"
                >
                  <svg-icon slot="prefix" icon-class="password" class="el-input__icon input-icon" />
                </el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <div class="margin10 bcGrey h60 padding10 box-shadow marginTop10" style="display: flex; justify-content: flex-end">
        <el-button size="medium" @click="cancel">取 消</el-button>
        <el-button type="primary" @click="onSubmit">提 交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import lodash from "lodash";
import { getToken } from "@/utils/auth";

export default {
  name: "UserEdit",
  components: {
  },
  props: {
    userId: {
      type: [String, Number], // 根据需要指定数据类型
      default: null, // 设置一个默认值，如空字符串
    },
  },
  data() {
    const equalToPassword = (rule, value, callback) => {
      if (this.form.password !== value) {
        callback(new Error("两次输入的密码不一致"));
      } else {
        callback();
      }
    };
    return {
      form: {
        userId: null,
        phonenumber: "",
        accountType: 0,
        status: true,
        password: "",
        confirmPassword: "",
      },
      isFirst: true,
      upload: {
        headers: { Authorization: getToken() },
        url: `${this.baseUrls.file}/upload?businessId=avatar`,
      },
      fileData: {},
      rules: {
        password: [
          { required: true, trigger: "blur", message: "请输入您的密码" },
          { min: 8, max: 20, message: "用户密码长度不小于8位", trigger: "blur" },
          { validator: this.validatePassword, trigger: "blur" }
        ],
        confirmPassword: [
          { required: true, trigger: "blur", message: "请再次输入您的密码" },
          { required: true, validator: this.equalToPassword, trigger: "blur" }
        ],
      },
    };
  },
  created() {
    if (this.isFirst) this.selectUser(this.userId);
  },
  mounted() {
    this.form.userId = this.userId;
  },
  methods: {
    validatePassword(rule, value, callback) {
      const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.#<>~|\\;:,])[A-Za-z\d@$!%*?&.#<>~|\\;:,]{8,}$/;
      if (!value) {
        return callback(new Error("密码不能为空"));
      } else if (!regex.test(value)) {
        callback(new Error("密码必须至少包含8位，且至少包含小写字母、大写字母、数字和特殊符号中的3种"));
      } else {
        callback();
      }
    },
    selectUser() {
      let url = `${this.baseUrls.user}/get/${this.userId}`;
      this.topsAjax.get(url).then(async (res) => {
        this.form.accountType = res.accountType;
        this.form.phonenumber = res.phonenumber;
        this.form.nickName = res.nickName;
        this.form.merchantId = res.merchantId;
        this.imageUrl = res.avatar;

        this.form.status = res.status == 0 ? true : false;
        // if (res.accountType == 1) {
        //   this.selectMerchantTree(0);
        //   this.merchantParams.singleMerchantId = res.merchantId;
        // } else if (res.accountType == 2) {
        //   this.queryMerchant(0);
        //   this.merchantParams.merchantUserId = res.merchantId;
        //   await this.getMerchant(res.merchantId);
        // }
        // if (res.roles) this.form.role = res.roles[0].roleId;
        // if (res.stores) this.storeList = res.stores;
      });
    },
    /**
     * 提交
     */
    onSubmit() {
      let data = {
        password: this.form.password.trim(),
        editPwd: 0,
      };
      data.userId = this.userId;
      if(this.form.password !== this.form.confirmPassword) {
        this.$message.error("两次输入的密码不一致!!!");
        return;
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          let url = `${this.baseUrls.user}/password/update`;
          this.topsAjax.post(url, data).then((response) => {
            this.$message({
              message: "设置密码成功",
              type: "success",
            });
            this.doSearch();
          });
        } else {
          this.$message({
            message: "验证失败，请检查输入!",
            type: "error",
          });
          return false;
        }
      });
      
    },
    cancel() {
      this.$emit("userSetting");
    },
    //存在跨域问题
    handleAvatarSuccess(res, file) {
      this.fileData = res.data;
      this.imageUrl = this.fileData.curl;
    },
    checkParams(o) {
      if (o == null || o == "" || o == undefined) {
        return true;
      } else {
        return false;
      }
    },
    triggerUpload() {
      this.$refs.upload.$el.querySelector('input[type="file"]').click();
    },
  },
};
</script>

<style lang="scss"></style>
<style lang="scss" scoped>
.user {
  padding: 5px;
  height: 100%;
  display: flex;
  width: 100%;
  flex-direction: column;
  flex: 1;
  background-color: white;

  &__body {
    display: flex;
    flex-direction: column;
    overflow: auto;
    height: 100%;
  }
}

.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 250px;
  height: 250px;
  line-height: 250px;
  text-align: center;
}

.avatar {
  width: 250px;
  height: 250px;
  display: block;
}
</style>
